"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultEncryptOptions = void 0;
exports.DefaultEncryptOptions = {
    encode: true,
    encryptedKey: '',
    prefixCiphertextWithIv: false
};
//# sourceMappingURL=types.js.map